// LINEプロフィールのエンティティ
export class LineProf {
  // ユーザーID DB型(*fk)
  public user_id?: string;
  // IDトークンの生成URL DB型(*varchar256)
  public iss?: string;
  // IDトークンの対象ユーザーID DB型(*varchar256)
  public sub?: string;
  // チャネルID DB型(*varchar256)
  public aud?: string;
  // トークンの有効期限（UNIXタイム） DB型(*varchar256)
  public exp?: string;
  // IDトークンの生成時間（UNIXタイム） DB型(*varchar256)
  public iat?: string;
  // ユーザーが使用した認証方法のリスト。 DB型(*varchar256)
  public amr?: string;
  // ユーザーの表示名 DB型(*varchar256)
  public name?: string;
  // ユーザープロフィールの画像URL DB型(*varchar256)
  public picture?: string;
  // ユーザーのメールアドレス DB型(*varchar256)
  public email?: string;
  static fromDB(record: { [column: string]: any; [column: number]: any }): LineProf {
    const entity = new LineProf();
    entity.user_id = record['user_id'];
    entity.iss = record['iss'];
    entity.sub = record['sub'];
    entity.aud = record['aud'];
    entity.exp = record['exp'];
    entity.iat = record['iat'];
    entity.amr = record['amr'];
    entity.name = record['name'];
    entity.picture = record['picture'];
    entity.email = record['email'];
    return entity;
  }
  static getTypeFitEntity(value: any): LineProf {
    const entity = new LineProf();
    entity.user_id = value.user_id;
    entity.iss = value.iss;
    entity.sub = value.sub;
    entity.aud = value.aud;
    entity.exp = value.exp;
    entity.iat = value.iat;
    entity.amr = value.amr;
    entity.name = value.name;
    entity.picture = value.picture;
    entity.email = value.email;
    return entity;
  }
}
